import React, { useState, useCallback } from 'react';

import { ButtonBase } from '@mui/material';
import Loader from '../../Loader';

import AccordeonNode from './AccordeonNode';

export default ({
  rst,
  frm,
  data,
  item,
  mode,
  formId,
  classes,
  setTrpl,
  groupId,
  concept,
  isNewNode,
  accFrmEdit,
  getTrplNode,
  objectTrpls,
  saveOnlyForm,
  getRstMetaData,
  onRstValueEdit,
  submitOnlyForm,
  removeTrplValue,
  optionalFields,
  mainFormNodeId,
  showOptionalRst,
  getRstTrplsData,
  accordeonRstData,
  onNodeRemoveClick,
  onRstTypeBtnClick,
  openObjectEditModal,
  removeAccordeonNode,
  formIndividuals,
  formConceptsByKeys,
  toggleUploadImgModal,
  onAccordeonEditClick,
  isDisableTrplEditing,
  getAutocompleteTrpls,
  optionalFieldsOptions,
  accordeonRestrictions,
  onChangeTextereaHeight,
  onAddNewAccordeonClick,
  updateDataOnRestoreTrpl,
  openTrplRenderPartsModal,
  onAccordeonAddNewNodeClick,
  onWidgetCheckboxesValueEdit,
  onNodeAddDropdownElementClick,
}) => {
  const [isAddBtnLoading, setAddBtnLoading] = useState(false);
  const [accOpened, setAccOpened] = useState({0: true});
  const [isDeleteBtnLoading, setDeleteBtnLoading] = useState({
    isLoading: false,
    index: null,
  });

  const toggleAccordeon = useCallback(
    (index, val) => {
      setAccOpened(prevState => ({
        ...prevState,
        [index]: val
      }))
    }, [accOpened]
  );

  const hideAddAndDeleteBtns = accordeonRstData && accordeonRstData.mode && accordeonRstData.mode !== 'WRITE';
  const hideOpenBtn = accordeonRstData && accordeonRstData.mode && accordeonRstData.mode === 'NONE';

  let maxBound = accordeonRstData && accordeonRstData.subjectMaxBound;

  if (rst) {
    return (
      <React.Fragment>
        {(objectTrpls && objectTrpls.length)
          ? objectTrpls.map((trpl, trplIndex) => {

            let accRequiredFieldsCount = 0;

            let trplOid = trpl.oid;

            if (frm) {
              frm.groups[0].forEach((frmGroup) => {
                frmGroup.items.forEach((item) => {
                  if (!accordeonRestrictions[frm.id][item.pid]) return null;

                  let itemRst = getRstTrplsData(item, accordeonRestrictions[frm.id][item.pid], trpl.oid, null, rst, trplIndex);

                  if (itemRst.trplArray.length < itemRst.subjectMinBound) {
                    accRequiredFieldsCount += 1;
                  }
                });
              });
            }

            return (
              <AccordeonNode
                rst={rst}
                frm={frm}
                mode={mode}
                trpl={trpl}
                data={data}
                item={item}
                key={trpl.tid}
                formId={formId}
                classes={classes}
                groupId={groupId}
                setTrpl={setTrpl}
                trplOid={trplOid}
                accIndex={trplIndex}
                trplIndex={trplIndex}
                isNewNode={isNewNode}
                mainConcept={concept}
                accFrmEdit={accFrmEdit}
                getTrplNode={getTrplNode}
                hideOpenBtn={hideOpenBtn}
                saveOnlyForm={saveOnlyForm}
                submitOnlyForm={submitOnlyForm}
                getRstMetaData={getRstMetaData}
                optionalFields={optionalFields}
                onRstValueEdit={onRstValueEdit}
                isOpened={accOpened[trplIndex]}
                getRstTrplsData={getRstTrplsData}
                toggleAccordeon={toggleAccordeon}
                showOptionalRst={showOptionalRst}
                removeTrplValue={removeTrplValue}
                formIndividuals={formIndividuals}
                formConceptsByKeys={formConceptsByKeys}
                onNodeRemoveClick={onNodeRemoveClick}
                onRstTypeBtnClick={onRstTypeBtnClick}
                isDeleteBtnLoading={isDeleteBtnLoading}
                setDeleteBtnLoading={setDeleteBtnLoading}
                openObjectEditModal={openObjectEditModal}
                removeAccordeonNode={removeAccordeonNode}
                hideAddAndDeleteBtns={hideAddAndDeleteBtns}
                isDisableTrplEditing={isDisableTrplEditing}
                onAccordeonEditClick={onAccordeonEditClick}
                getAutocompleteTrpls={getAutocompleteTrpls}
                toggleUploadImgModal={toggleUploadImgModal}
                accordeonRestrictions={accordeonRestrictions}
                accRequiredFieldsCount={accRequiredFieldsCount}
                onChangeTextereaHeight={onChangeTextereaHeight}
                openTrplRenderPartsModal={openTrplRenderPartsModal}
                optionalFieldsOptions={optionalFieldsOptions}
                updateDataOnRestoreTrpl={updateDataOnRestoreTrpl}
                onAccordeonAddNewNodeClick={onAccordeonAddNewNodeClick}
                onWidgetCheckboxesValueEdit={onWidgetCheckboxesValueEdit}
                onNodeAddDropdownElementClick={onNodeAddDropdownElementClick}
              />
            );
          })
        : null}

      {(!maxBound || !objectTrpls || (objectTrpls && objectTrpls.length < maxBound)) && !hideAddAndDeleteBtns ? (
        <div className={classes.p10}>
          {isAddBtnLoading ? (
            <Loader style={{ zoom: '0.7' }} />
          ) : (
            <ButtonBase
              size="small"
              disabled={isAddBtnLoading}
              className={`${classes.btn} ${classes.btnEmpty}`}
              style={{
                textTransform: 'capitalize',
                borderRadius: '15px',
              }}
              classes={{
                disabled: classes.btnNormalDisabled,
                focusVisible: classes.focusable,
              }}
              onClick={() => {
                setAddBtnLoading(true);
                onAddNewAccordeonClick(rst, groupId, () => {
                  setAddBtnLoading(false);
                });
              }}
            >
              Add
            </ButtonBase>
          )}
        </div>
      ) : null}
    </React.Fragment>
  );

  } else {
    return (
      <AccordeonNode
        rst={rst}
        frm={frm}
        data={data}
        item={item}
        accIndex={0}
        formId={formId}
        classes={classes}
        groupId={groupId}
        setTrpl={setTrpl}
        key={mainFormNodeId}
        mainConcept={concept}
        isNewNode={isNewNode}
        accFrmEdit={accFrmEdit}
        isOpened={accOpened[0]}
        getTrplNode={getTrplNode}
        trplOid={mainFormNodeId}
        hideOpenBtn={hideOpenBtn}
        saveOnlyForm={saveOnlyForm}
        submitOnlyForm={submitOnlyForm}
        getRstMetaData={getRstMetaData}
        optionalFields={optionalFields}
        onRstValueEdit={onRstValueEdit}
        getRstTrplsData={getRstTrplsData}
        toggleAccordeon={toggleAccordeon}
        showOptionalRst={showOptionalRst}
        removeTrplValue={removeTrplValue}
        formIndividuals={formIndividuals}
        formConceptsByKeys={formConceptsByKeys}
        onNodeRemoveClick={onNodeRemoveClick}
        onRstTypeBtnClick={onRstTypeBtnClick}
        isDeleteBtnLoading={isDeleteBtnLoading}
        setDeleteBtnLoading={setDeleteBtnLoading}
        openObjectEditModal={openObjectEditModal}
        removeAccordeonNode={removeAccordeonNode}
        hideAddAndDeleteBtns={hideAddAndDeleteBtns}
        isDisableTrplEditing={isDisableTrplEditing}
        onAccordeonEditClick={onAccordeonEditClick}
        getAutocompleteTrpls={getAutocompleteTrpls}
        toggleUploadImgModal={toggleUploadImgModal}
        accordeonRestrictions={accordeonRestrictions}
        onChangeTextereaHeight={onChangeTextereaHeight}
        openTrplRenderPartsModal={openTrplRenderPartsModal}
        optionalFieldsOptions={optionalFieldsOptions}
        updateDataOnRestoreTrpl={updateDataOnRestoreTrpl}
        onWidgetCheckboxesValueEdit={onWidgetCheckboxesValueEdit}
        onNodeAddDropdownElementClick={onNodeAddDropdownElementClick}
      />
    );
  }
};
